//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  // , "logisticsInfo"
  props: ["openStatus", "orderId"],
  data() {
    return {
      dialogVisible_logistics: false,
      logisticsInfo: {
        saleOrderTime: "",
        contacts: "",
        telPhone: "",
        remark: "",
      },
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_logistics = this.openStatus;
    },
    orderId(val1, val2) {
      console.log(val1, val2);
      if (val1 != "") {
        this.getLogisticsList();
      }
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.dialogVisible_logistics = false;
      this.$emit("closeStatus", true);
    },
    getLogisticsList() {
      this.$http.szOrder.getLogistics({ orderId: this.orderId }).then((res) => {
        if (res.status == 1) {
          if (res.data != null) {
            this.logisticsInfo = res.data;
          }else{
            this.logisticsInfo = []
          }
        }
      });
    },
  },
};
